import React from 'react';
import { CTAButton } from './CTAButton';
export const SolutionSection = () => {
  return <section className="w-full bg-[#faf7f2] py-16 px-4 md:px-8 lg:px-16" data-id="element-155">
      <div className="max-w-6xl mx-auto" data-id="element-156">
        <div className="text-center mb-12" data-id="element-157">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-gray-800 mb-4" data-id="element-158">
            Metoda Odwróconej Polarności
          </h2>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto" data-id="element-159">
            Rozwiązanie, które przywróciło bliskość i namiętność w setkach
            małżeństw po 40-tce. To nie jest kolejna porada w stylu "bądź
            bardziej sexy" - to kompletna transformacja, która działa, nawet gdy
            wszystko inne zawiodło.
          </p>
        </div>
        {/* Tydzień 1 */}
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 mb-16" data-id="element-160">
          <div className="md:w-1/2" data-id="element-161">
            <img src="https://0qy5hr4tin.ufs.sh/f/OWkzgeNAx0rA8gX7RpnMZQ5Os2JxuXzfCt3wIP9aGnrHyh6m" alt="Kobieta praktykująca jogę w salonie" className="w-full h-auto rounded-lg shadow-lg" data-id="element-162" />
          </div>
          <div className="md:w-1/2" data-id="element-163">
            <div className="inline-block bg-red-500 text-white px-4 py-1 rounded-full text-sm font-bold mb-4" data-id="element-164">
              TYDZIEŃ 1
            </div>
            <h3 className="font-serif text-2xl font-bold text-gray-800 mb-4" data-id="element-165">
              Odzyskanie Wewnętrznej Siły
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-166">
              W pierwszym tygodniu skupisz się na sobie - nie na nim. Poznasz
              techniki, które pozwolą Ci odbudować poczucie własnej wartości i
              kobiecości, niezależnie od reakcji męża. To fundament, bez którego
              nic innego nie zadziała.
            </p>
            <blockquote className="border-l-4 border-red-500 pl-4 italic text-gray-600 mb-4" data-id="element-167">
              "Po pierwszym tygodniu poczułam zmianę w sobie. Nie chodziło o to,
              że mąż nagle zaczął mnie zauważać - chodziło o to, że JA zaczęłam
              siebie zauważać. To był pierwszy krok." - Magda, 41 lat
            </blockquote>
          </div>
        </div>
        {/* Tydzień 2 */}
        <div className="flex flex-col md:flex-row-reverse items-center gap-8 md:gap-12 mb-16" data-id="element-168">
          <div className="md:w-1/2" data-id="element-169">
            <img src="https://0qy5hr4tin.ufs.sh/f/OWkzgeNAx0rAp5QhIejl793OHPVgbNZU4FaeQGumMdprBKk2" alt="Kobieta śmiejąca się z przyjaciółkami w kawiarni" className="w-full h-auto rounded-lg shadow-lg" data-id="element-170" />
          </div>
          <div className="md:w-1/2" data-id="element-171">
            <div className="inline-block bg-red-500 text-white px-4 py-1 rounded-full text-sm font-bold mb-4" data-id="element-172">
              TYDZIEŃ 2
            </div>
            <h3 className="font-serif text-2xl font-bold text-gray-800 mb-4" data-id="element-173">
              Przerwanie Błędnego Koła
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-174">
              W drugim tygodniu nauczysz się, jak przerwać destrukcyjny cykl
              desperacji i odrzucenia. Poznasz techniki, które sprawią, że mąż
              zacznie się zastanawiać, co się z Tobą dzieje - w pozytywnym
              sensie. To etap, w którym zaczynasz odzyskiwać kontrolę.
            </p>
            <blockquote className="border-l-4 border-red-500 pl-4 italic text-gray-600 mb-4" data-id="element-175">
              "Kiedy przestałam gonić za jego uwagą i zaczęłam stosować te
              techniki, coś się zmieniło. Pewnego wieczoru zapytał: 'Co się z
              tobą dzieje ostatnio?'. Wtedy wiedziałam, że to działa." - Beata,
              46 lat
            </blockquote>
          </div>
        </div>
        {/* Tydzień 3 */}
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12 mb-12" data-id="element-176">
          <div className="md:w-1/2" data-id="element-177">
            <img src="https://0qy5hr4tin.ufs.sh/f/OWkzgeNAx0rAp0Fvegl793OHPVgbNZU4FaeQGumMdprBKk2x" alt="Para przytulająca się w kuchni" className="w-full h-auto rounded-lg shadow-lg" data-id="element-178" />
          </div>
          <div className="md:w-1/2" data-id="element-179">
            <div className="inline-block bg-red-500 text-white px-4 py-1 rounded-full text-sm font-bold mb-4" data-id="element-180">
              TYDZIEŃ 3
            </div>
            <h3 className="font-serif text-2xl font-bold text-gray-800 mb-4" data-id="element-181">
              Odbudowa Namiętności
            </h3>
            <p className="text-gray-700 mb-4" data-id="element-182">
              Trzeci tydzień to czas, w którym wprowadzasz elementy, które
              odbudowują namiętność - ale w zupełnie inny sposób, niż próbowałaś
              do tej pory. To nie są sztuczki, ale głęboka transformacja
              dynamiki Waszej relacji.
            </p>
            <blockquote className="border-l-4 border-red-500 pl-4 italic text-gray-600 mb-4" data-id="element-183">
              "Po trzecim tygodniu mój mąż zaczął mnie znowu dotykać. Nie tylko
              w sypialni - chodziło o te małe gesty: dłoń na plecach,
              przytulenie w kuchni. Wróciliśmy do siebie." - Kasia, 44 lata
            </blockquote>
          </div>
        </div>
        <div className="text-center mt-10" data-id="element-184">
          <CTAButton text="Chcę przerwać Błędne Koło" data-id="element-185" />
        </div>
      </div>
    </section>;
};